import React from 'react';
import { translate } from '../../../types/translation/Translator';
import { TranslationKey } from '../../../types/translation/TranslationKey';

export default function NotFound({ text }: { text?: string }) {
  return (
    <div className='flex h-full w-full justify-center'>
      <p>{translate({ key: TranslationKey.entityNotFound })}</p>
    </div>
  );
}
